import { Link } from "react-router-dom";

const Btns = ({ children }) => (
  <div className="flex flex-wrap gap-3 mt-4">{children}</div>
);

const faqData = [
    {
      question: "Quels sont les horaires d'ouverture du club ?",
      answer: () => (<>
        <p>Le club est ouvert du lundi au vendredi de 18h à 22h, et le samedi de 10h à 18h. Les horaires peuvent varier selon les créneaux d'entraînement et les compétitions.</p>
        <Btns>
          <Link to='/creneaux/creneauxAdultes' className="btn-brand text-xs">Voir les créneaux</Link>
        </Btns>
      </>)
    },
    {
      question: "Comment puis-je m'inscrire au club ?",
      answer: () => (<>
        <p>Vous pouvez vous inscrire directement sur notre site web dans la section 'Inscription', ou venir nous rencontrer au club pendant les horaires d'ouverture. N'oubliez pas d'apporter un certificat médical pour la pratique du badminton.</p>
        <Btns>
          <Link to='/inscription/modalite' className="btn-brand text-xs">S'inscrire en ligne</Link>
        </Btns>
      </>)
    },
    {
      question: "Proposez-vous des cours pour débutants ?",
      answer: () => (<>
        <p>Oui, nous proposons des cours pour tous les niveaux, y compris les débutants. Nos entraîneurs qualifiés vous aideront à progresser à votre rythme.</p>
        <Btns>
          <Link to='/entrainements' className="btn-brand text-xs">Voir les entraîneurs</Link>
          <Link to='/creneaux/creneauxAdultes' className="btn-ghost text-xs">Voir les créneaux</Link>
        </Btns>
      </>)
    },
    {
      question: "Faut-il apporter son propre équipement ?",
      answer: () => (<>
        <p>Pour commencer, vous pouvez emprunter des raquettes au club. Cependant, nous recommandons d'avoir votre propre raquette à long terme. Des volants sont fournis pour les entraînements et les matchs.</p>
        <Btns>
          <a href="https://www.lardesports.com/" target="_blank" rel="noopener noreferrer" className="btn-brand text-xs">
            Équipez-vous chez notre partenaire
          </a>
        </Btns>
      </>)
    },
    {
      question: "Y a-t-il un âge minimum pour s'inscrire ?",
      answer: () => (<>
        <p>Nous accueillons les joueurs à partir de 6 ans dans notre école de badminton. Pour les adultes, il n'y a pas de limite d'âge.</p>
        <Btns>
          <Link to='/creneaux/creneauxJeunes' className="btn-brand text-xs">Voir les créneaux jeunes</Link>
        </Btns>
      </>)
    },
    {
      question: "Organisez-vous des tournois ?",
      answer: () => (<>
        <p>Oui, nous organisons régulièrement des tournois internes et participons à des compétitions départementales et régionales. C'est une excellente façon de progresser et de rencontrer d'autres joueurs.</p>
        <Btns>
          <Link to='/agenda' className="btn-brand text-xs">Voir l'agenda de la saison</Link>
        </Btns>
      </>)
    },
    {
      question: "Qu'est-ce que le Pass'Sport et comment puis-je en bénéficier ?",
      answer: () => (
        <>
          <p>Le Pass'Sport est une allocation de 50€ par enfant pour financer tout ou partie de son inscription dans une association sportive. Il s'adresse aux enfants de 6 à 17 ans bénéficiaires de l'allocation de rentrée scolaire, de l'allocation d'éducation de l'enfant handicapé ou de l'allocation aux adultes handicapés (entre 16 et 18 ans).</p>
          <Btns>
            <Link to='/inscription/passSport' className="btn-brand text-xs">En savoir plus sur le Pass'Sport</Link>
          </Btns>
        </>
      )
    },
    {
      question: "Quels sont les tarifs d'adhésion au club ?",
      answer: () => (
        <>
          <p>Nos tarifs varient selon les catégories (jeunes, adultes, compétiteurs) et les formules choisies. Ils incluent la licence fédérale et l'accès aux créneaux correspondants.</p>
          <Btns>
            <Link to='/creneaux/creneauxAdultes' className="btn-brand text-xs">Voir les tarifs adultes</Link>
            <Link to='/creneaux/creneauxJeunes' className="btn-ghost text-xs">Voir les tarifs jeunes</Link>
          </Btns>
        </>
      )
    },
    {
      question: "Proposez-vous des séances d'essai ?",
      answer: () => (
        <p>Oui, nous proposons 2 séances d'essai gratuites pour vous permettre de découvrir notre club et la pratique du badminton. Il suffit de vous présenter à l'un de nos créneaux avec une tenue de sport. Nous vous prêterons une raquette pour l'occasion.</p>
      )
    },
    {
      question: "Comment se déroule une séance type d'entraînement ?",
      answer: () => (
        <p>Une séance type dure généralement 1h30 à 2h. Elle commence par un échauffement, suivi d'exercices techniques et/ou tactiques, et se termine par des matchs. L'intensité et le contenu varient selon le niveau du groupe et les objectifs de la séance.</p>
      )
    },
    {
      question: "Le club propose-t-il des partenariats ou des réductions chez des équipementiers ?",
      answer: () => (
        <>
          <p>Oui, nous avons des partenariats avec des équipementiers qui offrent des réductions à nos adhérents. Vous pouvez bénéficier de ces avantages pour l'achat de raquettes, chaussures, et autres équipements de badminton.</p>
          <Btns>
            <a href="https://badaddict.fr" target="_blank" rel="noopener noreferrer" className="btn-brand text-xs">
              Découvrir notre partenaire équipementier
            </a>
          </Btns>
        </>
      )
    }
];

export { faqData };
